import "./App.css";
import React,{useEffect} from "react";
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";
import Projects from "./components/Projects";
import Footer from "./components/Footer";
function App() {
  useEffect(() => {
    document.title = "Rishabh Sharma";
  }, [])
  return (
    <div>
        <Navbar />
        <Hero />
        <Projects />
        <Footer />
    </div>
  );
}

export default App;
